import React from 'react';
import '../styles/terms.css';

const TermsConditions = ({ onClose }) => {
    return (
        <div className="modal">
            <div className="modal-content terms-section">
                <span className="close" onClick={onClose}>&times;</span>
                <h1>Cookie Policy</h1>
                <p><strong>Effective Date:</strong> Sat Aug 23, 2025</p>
                <p><strong>Last Updated:</strong> Sat Aug 23, 2025</p>

                <p>Intellommerce.ai. ("Intellommerce", "we", "us", or "our") uses cookies and similar tracking
                    technologies on our website and automated digital transformation services. This comprehensive Cookie
                    Policy explains what these technologies are, why we use them, and your rights to control our use of
                    them. This policy complies with the EU ePrivacy Directive, GDPR, CCPA, and other applicable laws
                    regarding the use of cookies and similar technologies.</p>

                <h2>1. What Are Cookies and Similar Technologies</h2>

                <h3>1.1 Cookies</h3>
                <p>Cookies are small text files that are placed on your computer or mobile device when you visit a
                    website. They are widely used to make websites work efficiently and provide information to website
                    owners. Cookies contain a unique identifier and may include:</p>
                <ul>
                    <li><strong>Session Cookies:</strong> Temporary cookies that expire when you close your browser</li>
                    <li><strong>Persistent Cookies:</strong> Cookies that remain on your device for a set period or
                        until manually deleted
                    </li>
                    <li><strong>First-Party Cookies:</strong> Set by the website you're visiting (intellommerce.com)
                    </li>
                    <li><strong>Third-Party Cookies:</strong> Set by domains other than the one you're visiting</li>
                </ul>

                <h3>1.2 Other Tracking Technologies</h3>
                <ul>
                    <li><strong>Web Beacons/Pixel Tags:</strong> Small transparent images embedded in web pages or
                        emails that track user behavior
                    </li>
                    <li><strong>Local Storage:</strong> HTML5 local storage and session storage that store data in your
                        browser
                    </li>
                    <li><strong>Device Fingerprinting:</strong> Techniques that collect device configuration information
                        to create a unique identifier
                    </li>
                    <li><strong>ETags:</strong> HTTP entity tags used for web cache validation that can be used for
                        tracking
                    </li>
                    <li><strong>JavaScript:</strong> Code that runs in your browser and may collect information about
                        your interactions
                    </li>
                    <li><strong>SDKs:</strong> Software development kits in mobile applications that may collect device
                        information
                    </li>
                    <li><strong>Server Logs:</strong> Automatic collection of IP addresses, browser types, and access
                        times
                    </li>
                </ul>

                <h3>1.3 Technology-Specific Identifiers</h3>
                <ul>
                    <li><strong>Advertising IDs:</strong> Mobile advertising identifiers (IDFA for iOS, AAID for
                        Android)
                    </li>
                    <li><strong>Browser Storage:</strong> IndexedDB, WebSQL, and other browser storage mechanisms</li>
                    <li><strong>Flash Cookies (LSOs):</strong> Local shared objects used by Adobe Flash (being phased
                        out)
                    </li>
                    <li><strong>Silverlight Application Storage:</strong> Similar to Flash cookies for Microsoft
                        Silverlight
                    </li>
                </ul>

                <h2>2. How We Use Cookies and Similar Technologies</h2>

                <h3>2.1 Essential/Strictly Necessary Cookies</h3>
                <p>These cookies are essential for the website to function properly and cannot be disabled. They
                    include:</p>
                <table border="1" style={{width:'100%', borderCollapse: 'collapse', margin: '10px 0'}}>
                    <tr>
                        <th style={{padding: '10px'}}>Cookie Name</th>
                        <th style={{padding: '10px'}}>Purpose</th>
                        <th style={{padding: '10px'}}>Duration</th>
                        <th style={{padding: '10px'}}>Provider</th>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>session_id</td>
                        <td style={{padding: '10px'}}>Maintains user session state</td>
                        <td style={{padding: '10px'}}>Session</td>
                        <td style={{padding: '10px'}}>Intellommerce</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>csrf_token</td>
                        <td style={{padding: '10px'}}>Security token to prevent cross-site request forgery</td>
                        <td style={{padding: '10px'}}>Session</td>
                        <td style={{padding: '10px'}}>Intellommerce</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>auth_token</td>
                        <td style={{padding: '10px'}}>Authentication and secure login</td>
                        <td style={{padding: '10px'}}>14 days</td>
                        <td style={{padding: '10px'}}>Intellommerce</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>load_balancer</td>
                        <td style={{padding: '10px'}}>Distributes traffic across servers</td>
                        <td style={{padding: '10px'}}>Session</td>
                        <td style={{padding: '10px'}}>Intellommerce</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>cookie_consent</td>
                        <td style={{padding: '10px'}}>Stores your cookie preferences</td>
                        <td style={{padding: '10px'}}>1 year</td>
                        <td style={{padding: '10px'}}>Intellommerce</td>
                    </tr>
                </table>

                <h3>2.2 Performance/Analytics Cookies</h3>
                <p>These cookies help us understand how visitors interact with our website and services:</p>
                <table border="1" style={{width:'100%', borderCollapse: 'collapse', margin: '10px 0'}}>
                    <tr>
                        <th style={{padding: '10px'}}>Cookie Name</th>
                        <th style={{padding: '10px'}}>Purpose</th>
                        <th style={{padding: '10px'}}>Duration</th>
                        <th style={{padding: '10px'}}>Provider</th>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>_ga</td>
                        <td style={{padding: '10px'}}>Google Analytics - distinguishes unique users</td>
                        <td style={{padding: '10px'}}>2 years</td>
                        <td style={{padding: '10px'}}>Google</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>_gid</td>
                        <td style={{padding: '10px'}}>Google Analytics - distinguishes users</td>
                        <td style={{padding: '10px'}}>24 hours</td>
                        <td style={{padding: '10px'}}>Google</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>_gat</td>
                        <td style={{padding: '10px'}}>Google Analytics - throttle request rate</td>
                        <td style={{padding: '10px'}}>1 minute</td>
                        <td style={{padding: '10px'}}>Google</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>_hjid</td>
                        <td style={{padding: '10px'}}>Hotjar - unique user identifier</td>
                        <td style={{padding: '10px'}}>1 year</td>
                        <td style={{padding: '10px'}}>Hotjar</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>mp_[hash]</td>
                        <td style={{padding: '10px'}}>Mixpanel - track user interactions</td>
                        <td style={{padding: '10px'}}>1 year</td>
                        <td style={{padding: '10px'}}>Mixpanel</td>
                    </tr>
                </table>

                <h3>2.3 Functionality/Preference Cookies</h3>
                <p>These cookies enable personalized features and remember your preferences:</p>
                <table border="1" style={{width:'100%', borderCollapse: 'collapse', margin: '10px 0'}}>
                    <tr>
                        <th style={{padding: '10px'}}>Cookie Name</th>
                        <th style={{padding: '10px'}}>Purpose</th>
                        <th style={{padding: '10px'}}>Duration</th>
                        <th style={{padding: '10px'}}>Provider</th>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>language_preference</td>
                        <td style={{padding: '10px'}}>Stores your language selection</td>
                        <td style={{padding: '10px'}}>1 year</td>
                        <td style={{padding: '10px'}}>Intellommerce</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>timezone</td>
                        <td style={{padding: '10px'}}>Stores your timezone preference</td>
                        <td style={{padding: '10px'}}>1 year</td>
                        <td style={{padding: '10px'}}>Intellommerce</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>theme_preference</td>
                        <td style={{padding: '10px'}}>Dark/light mode preference</td>
                        <td style={{padding: '10px'}}>1 year</td>
                        <td style={{padding: '10px'}}>Intellommerce</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>dashboard_layout</td>
                        <td style={{padding: '10px'}}>Remembers your dashboard configuration</td>
                        <td style={{padding: '10px'}}>6 months</td>
                        <td style={{padding: '10px'}}>Intellommerce</td>
                    </tr>
                </table>

                <h3>2.4 Marketing/Advertising Cookies</h3>
                <p>These cookies track your browsing habits to show you relevant advertisements:</p>
                <table border="1" style={{width:'100%', borderCollapse: 'collapse', margin: '10px 0'}}>
                    <tr>
                        <th style={{padding: '10px'}}>Cookie Name</th>
                        <th style={{padding: '10px'}}>Purpose</th>
                        <th style={{padding: '10px'}}>Duration</th>
                        <th style={{padding: '10px'}}>Provider</th>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>_fbp</td>
                        <td style={{padding: '10px'}}>Facebook Pixel - track visits for advertising</td>
                        <td style={{padding: '10px'}}>3 months</td>
                        <td style={{padding: '10px'}}>Facebook</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>fr</td>
                        <td style={{padding: '10px'}}>Facebook - deliver and measure advertisements</td>
                        <td style={{padding: '10px'}}>3 months</td>
                        <td style={{padding: '10px'}}>Facebook</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>IDE</td>
                        <td style={{padding: '10px'}}>Google DoubleClick - measure ad effectiveness</td>
                        <td style={{padding: '10px'}}>13 months</td>
                        <td style={{padding: '10px'}}>Google</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>_gcl_au</td>
                        <td style={{padding: '10px'}}>Google AdSense - experiment with ad efficiency</td>
                        <td style={{padding: '10px'}}>3 months</td>
                        <td style={{padding: '10px'}}>Google</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>_li_id</td>
                        <td style={{padding: '10px'}}>LinkedIn Ads - track conversions</td>
                        <td style={{padding: '10px'}}>6 months</td>
                        <td style={{padding: '10px'}}>LinkedIn</td>
                    </tr>
                </table>

                <h3>2.5 Social Media Cookies</h3>
                <p>These cookies enable social media features and track sharing:</p>
                <table border="1" style={{width:'100%', borderCollapse: 'collapse', margin: '10px 0'}}>
                    <tr>
                        <th style={{padding: '10px'}}>Cookie Name</th>
                        <th style={{padding: '10px'}}>Purpose</th>
                        <th style={{padding: '10px'}}>Duration</th>
                        <th style={{padding: '10px'}}>Provider</th>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>datr</td>
                        <td style={{padding: '10px'}}>Facebook - fraud prevention</td>
                        <td style={{padding: '10px'}}>2 years</td>
                        <td style={{padding: '10px'}}>Facebook</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>bcookie</td>
                        <td style={{padding: '10px'}}>LinkedIn - browser identification</td>
                        <td style={{padding: '10px'}}>2 years</td>
                        <td style={{padding: '10px'}}>LinkedIn</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>guest_id</td>
                        <td style={{padding: '10px'}}>Twitter - identify and track visitors</td>
                        <td style={{padding: '10px'}}>2 years</td>
                        <td style={{padding: '10px'}}>Twitter</td>
                    </tr>
                </table>

                <h2>3. Legal Basis for Using Cookies</h2>

                <h3>3.1 Consent Requirements by Region</h3>
                <ul>
                    <li><strong>European Union (ePrivacy Directive & GDPR):</strong> Explicit consent required for all
                        non-essential cookies
                    </li>
                    <li><strong>United Kingdom:</strong> Similar to EU, requires clear consent for non-essential cookies
                    </li>
                    <li><strong>California (CCPA/CPRA):</strong> Right to opt-out of sale/sharing of personal
                        information via cookies
                    </li>
                    <li><strong>Canada (CASL/PIPEDA):</strong> Implied consent for functional cookies, express consent
                        for tracking
                    </li>
                    <li><strong>Brazil (LGPD):</strong> Consent required for non-essential cookies and tracking</li>
                    <li><strong>Australia (Privacy Act):</strong> Clear notice and implied consent acceptable for most
                        cookies
                    </li>
                    <li><strong>China (PIPL):</strong> Separate consent required for cookies processing personal
                        information
                    </li>
                </ul>

                <h3>3.2 Legal Bases Under GDPR</h3>
                <p>We rely on the following legal bases for cookie usage:</p>
                <ul>
                    <li><strong>Consent:</strong> For analytics, marketing, and preference cookies</li>
                    <li><strong>Legitimate Interests:</strong> For essential security and fraud prevention cookies</li>
                    <li><strong>Contract Performance:</strong> For cookies necessary to provide requested services</li>
                    <li><strong>Legal Obligation:</strong> For cookies required for compliance and record-keeping</li>
                </ul>

                <h2>4. Cookie Consent Management</h2>

                <h3>4.1 Initial Consent</h3>
                <p>When you first visit our website, you will see a cookie consent banner that allows you to:</p>
                <ul>
                    <li>Accept all cookies</li>
                    <li>Reject all non-essential cookies</li>
                    <li>Customize your cookie preferences by category</li>
                    <li>Learn more about our cookie usage</li>
                </ul>

                <h3>4.2 Granular Consent Options</h3>
                <p>You can control cookies by category:</p>
                <ul>
                    <li><strong>Essential Cookies:</strong> Always active (required for site functionality)</li>
                    <li><strong>Performance Cookies:</strong> Optional (helps us improve our services)</li>
                    <li><strong>Functionality Cookies:</strong> Optional (enables personalization features)</li>
                    <li><strong>Marketing Cookies:</strong> Optional (enables targeted advertising)</li>
                    <li><strong>Social Media Cookies:</strong> Optional (enables social sharing features)</li>
                </ul>

                <h3>4.3 Consent Withdrawal</h3>
                <p>You can withdraw or modify your consent at any time by:</p>
                <ul>
                    <li>Clicking the "Cookie Preferences" link in the website footer</li>
                    <li>Using our Cookie Preference Center</li>
                    <li>Clearing your cookies through browser settings</li>
                    <li>Contacting us at privacy@intellommerce.ai</li>
                </ul>

                <h2>5. Managing Cookies Through Your Browser</h2>

                <h3>5.1 Browser Cookie Settings</h3>
                <p>Most browsers allow you to control cookies through their settings:</p>
                <ul>
                    <li><strong>Chrome:</strong> Settings > Privacy and security > Cookies and other site data</li>
                    <li><strong>Firefox:</strong> Settings > Privacy & Security > Cookies and Site Data</li>
                    <li><strong>Safari:</strong> Preferences > Privacy > Cookies and website data</li>
                    <li><strong>Edge:</strong> Settings > Privacy, search, and services > Cookies and site permissions
                    </li>
                    <li><strong>Opera:</strong> Settings > Advanced > Privacy & security > Cookies</li>
                </ul>

                <h3>5.2 Mobile Device Settings</h3>
                <ul>
                    <li><strong>iOS:</strong> Settings > Safari > Block All Cookies</li>
                    <li><strong>Android Chrome:</strong> Settings > Site Settings > Cookies</li>
                    <li><strong>Samsung Internet:</strong> Settings > Privacy and security > Accept cookies</li>
                </ul>

                <h3>5.3 Consequences of Blocking Cookies</h3>
                <p>Please note that blocking certain cookies may impact your experience:</p>
                <ul>
                    <li>Loss of personalized settings and preferences</li>
                    <li>Inability to use certain features or services</li>
                    <li>Need to re-enter information on each visit</li>
                    <li>Reduced website performance and functionality</li>
                    <li>Less relevant content and advertisements</li>
                </ul>

                <h2>6. Third-Party Cookie Providers</h2>

                <h3>6.1 Analytics Providers</h3>
                <ul>
                    <li><strong>Google Analytics:</strong> <a href="https://policies.google.com/privacy">Privacy
                        Policy</a> | <a href="https://tools.google.com/dlpage/gaoptout">Opt-out</a></li>
                    <li><strong>Adobe Analytics:</strong> <a href="https://www.adobe.com/privacy/policy.html">Privacy
                        Policy</a> | <a href="https://www.adobe.com/privacy/opt-out.html">Opt-out</a></li>
                    <li><strong>Mixpanel:</strong> <a href="https://mixpanel.com/legal/privacy-policy/">Privacy
                        Policy</a> | <a href="https://mixpanel.com/optout/">Opt-out</a></li>
                    <li><strong>Hotjar:</strong> <a href="https://www.hotjar.com/legal/policies/privacy/">Privacy
                        Policy</a> | <a href="https://www.hotjar.com/legal/compliance/opt-out">Opt-out</a></li>
                    <li><strong>Segment:</strong> <a href="https://segment.com/legal/privacy/">Privacy Policy</a> |
                        Contact support for opt-out
                    </li>
                </ul>

                <h3>6.2 Advertising Partners</h3>
                <ul>
                    <li><strong>Google Ads:</strong> <a href="https://policies.google.com/technologies/ads">Ad
                        Policy</a> | <a href="https://adssettings.google.com/">Ad Settings</a></li>
                    <li><strong>Facebook/Meta:</strong> <a href="https://www.facebook.com/policy/cookies/">Cookie
                        Policy</a> | <a href="https://www.facebook.com/ads/preferences/">Ad Preferences</a></li>
                    <li><strong>LinkedIn:</strong> <a href="https://www.linkedin.com/legal/cookie-policy">Cookie
                        Policy</a> | <a
                        href="https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out">Opt-out</a></li>
                    <li><strong>Twitter:</strong> <a
                        href="https://help.twitter.com/en/rules-and-policies/twitter-cookies">Cookie Policy</a> | <a
                        href="https://twitter.com/personalization">Privacy Settings</a></li>
                    <li><strong>Amazon Advertising:</strong> <a href="https://www.amazon.com/adprefs">Ad Preferences</a>
                    </li>
                </ul>

                <h3>6.3 Industry Opt-Out Tools</h3>
                <ul>
                    <li><strong>Network Advertising Initiative (NAI):</strong> <a
                        href="https://optout.networkadvertising.org/">optout.networkadvertising.org</a></li>
                    <li><strong>Digital Advertising Alliance (DAA):</strong> <a
                        href="https://optout.aboutads.info/">optout.aboutads.info</a></li>
                    <li><strong>European Digital Advertising Alliance:</strong> <a
                        href="https://www.youronlinechoices.eu/">youronlinechoices.eu</a></li>
                    <li><strong>Canadian Digital Advertising Alliance:</strong> <a
                        href="https://youradchoices.ca/">youradchoices.ca</a></li>
                    <li><strong>AppChoices Mobile App:</strong> Available for iOS and Android</li>
                </ul>

                <h2>7. Specific Cookie Categories for Digital Transformation Services</h2>

                <h3>7.1 AI and Machine Learning Cookies</h3>
                <p>Cookies specific to our automated services:</p>
                <ul>
                    <li><strong>model_preferences:</strong> Stores your AI model selection preferences</li>
                    <li><strong>training_session:</strong> Tracks machine learning training sessions</li>
                    <li><strong>algorithm_config:</strong> Saves your algorithm configuration settings</li>
                    <li><strong>automation_state:</strong> Maintains state of automated workflows</li>
                </ul>

                <h3>7.2 Platform Integration Cookies</h3>
                <ul>
                    <li><strong>api_session:</strong> Maintains API authentication state</li>
                    <li><strong>integration_tokens:</strong> Stores encrypted tokens for third-party integrations</li>
                    <li><strong>webhook_config:</strong> Saves webhook configuration preferences</li>
                    <li><strong>sync_state:</strong> Tracks data synchronization status</li>
                </ul>

                <h3>7.3 Performance Monitoring Cookies</h3>
                <ul>
                    <li><strong>performance_metrics:</strong> Collects platform performance data</li>
                    <li><strong>error_tracking:</strong> Logs errors for debugging purposes</li>
                    <li><strong>latency_monitor:</strong> Measures response times</li>
                    <li><strong>resource_usage:</strong> Tracks resource utilization</li>
                </ul>

                <h2>8. Cross-Border Cookie Usage</h2>

                <h3>8.1 International Data Transfers</h3>
                <p>Cookies may result in data transfers across borders. We ensure appropriate safeguards through:</p>
                <ul>
                    <li>Standard Contractual Clauses with third-party providers</li>
                    <li>Adequacy decisions where applicable</li>
                    <li>Privacy Shield principles (for historical transfers)</li>
                    <li>Your explicit consent where required</li>
                </ul>

                <h3>8.2 Regional Cookie Differences</h3>
                <p>Cookie usage may vary by region based on local laws:</p>
                <ul>
                    <li><strong>EU/UK:</strong> Strictest consent requirements, all non-essential cookies require opt-in
                    </li>
                    <li><strong>US:</strong> Varies by state, generally notice and opt-out approach</li>
                    <li><strong>Asia-Pacific:</strong> Varies by country, from notice-only to explicit consent</li>
                    <li><strong>Latin America:</strong> Increasing regulation, generally following EU model</li>
                </ul>

                <h2>9. Cookie Security</h2>

                <h3>9.1 Security Measures</h3>
                <p>We implement security measures to protect cookie data:</p>
                <ul>
                    <li><strong>Secure Flag:</strong> Cookies transmitted only over HTTPS</li>
                    <li><strong>HttpOnly Flag:</strong> Prevents client-side script access to sensitive cookies</li>
                    <li><strong>SameSite Attribute:</strong> Prevents CSRF attacks</li>
                    <li><strong>Encryption:</strong> Sensitive cookie data is encrypted</li>
                    <li><strong>Regular Audits:</strong> Security assessments of cookie usage</li>
                </ul>

                <h3>9.2 Cookie Integrity</h3>
                <ul>
                    <li>Digital signatures to prevent tampering</li>
                    <li>Regular rotation of session identifiers</li>
                    <li>Automatic expiration of sensitive cookies</li>
                    <li>Monitoring for suspicious cookie activity</li>
                </ul>

                <h2>10. Special Considerations</h2>

                <h3>10.1 Do Not Track (DNT) Signals</h3>
                <p>Currently, there is no universal standard for processing DNT signals. While we don't respond to DNT
                    signals, we provide other methods to control tracking through our Cookie Preference Center and this
                    policy.</p>

                <h3>10.2 Global Privacy Control (GPC)</h3>
                <p>We recognize and respond to Global Privacy Control signals where legally required. When we detect a
                    GPC signal:</p>
                <ul>
                    <li>We will not sell or share your personal information</li>
                    <li>We will limit the use of advertising cookies</li>
                    <li>We will honor your privacy preferences automatically</li>
                    <li>This applies in jurisdictions that recognize GPC (e.g., California)</li>
                </ul>

                <h3>10.3 Children's Privacy and Cookies</h3>
                <p>Our services are not directed to children under 16. We do not knowingly:</p>
                <ul>
                    <li>Place cookies on devices used by children</li>
                    <li>Collect personal information from children through cookies</li>
                    <li>Use interest-based advertising cookies for children</li>
                    <li>Track children's online activities</li>
                </ul>

                <h3>10.4 Accessibility</h3>
                <p>Our cookie consent mechanisms are designed to be accessible:</p>
                <ul>
                    <li>Keyboard navigable cookie preference center</li>
                    <li>Screen reader compatible consent banners</li>
                    <li>Clear, plain language descriptions</li>
                    <li>Alternative formats available upon request</li>
                </ul>

                <h2>11. Cookie Auditing and Compliance</h2>

                <h3>11.1 Regular Cookie Audits</h3>
                <p>We conduct regular audits to ensure compliance:</p>
                <ul>
                    <li><strong>Quarterly Reviews:</strong> Comprehensive cookie inventory updates</li>
                    <li><strong>Annual Assessments:</strong> Full compliance and necessity reviews</li>
                    <li><strong>Third-Party Audits:</strong> Independent verification of cookie practices</li>
                    <li><strong>Automated Scanning:</strong> Continuous monitoring for unauthorized cookies</li>
                </ul>

                <h3>11.2 Compliance Monitoring</h3>
                <ul>
                    <li>Real-time consent tracking and reporting</li>
                    <li>Geographic-based consent management</li>
                    <li>Automatic cookie blocking for non-consented users</li>
                    <li>Compliance dashboards and metrics</li>
                </ul>

                <h3>11.3 Data Protection Impact Assessments</h3>
                <p>We conduct DPIAs for new cookie implementations that may pose privacy risks, evaluating:</p>
                <ul>
                    <li>Necessity and proportionality of cookie usage</li>
                    <li>Privacy risks to individuals</li>
                    <li>Mitigation measures and safeguards</li>
                    <li>Compliance with applicable laws</li>
                </ul>

                <h2>12. Industry-Specific Cookie Usage</h2>

                <h3>12.1 B2B Platform Cookies</h3>
                <p>Specific cookies for business customers:</p>
                <ul>
                    <li><strong>account_hierarchy:</strong> Manages multi-user business accounts</li>
                    <li><strong>license_tracking:</strong> Monitors software license usage</li>
                    <li><strong>team_preferences:</strong> Stores team-wide settings</li>
                    <li><strong>billing_session:</strong> Manages billing and invoice access</li>
                </ul>

                <h3>12.2 API and Developer Cookies</h3>
                <ul>
                    <li><strong>api_key_session:</strong> Maintains developer portal sessions</li>
                    <li><strong>sandbox_config:</strong> Stores API testing environment settings</li>
                    <li><strong>documentation_progress:</strong> Tracks documentation reading progress</li>
                    <li><strong>code_samples:</strong> Remembers preferred programming language</li>
                </ul>

                <h3>12.3 Support and Service Cookies</h3>
                <ul>
                    <li><strong>support_ticket:</strong> Maintains support session continuity</li>
                    <li><strong>chat_session:</strong> Enables live chat functionality</li>
                    <li><strong>kb_preferences:</strong> Stores knowledge base preferences</li>
                    <li><strong>feedback_token:</strong> Tracks feedback submission status</li>
                </ul>

                <h2>13. Cookie Data Retention</h2>

                <h3>13.1 Retention Periods by Cookie Type</h3>
                <table border="1" style={{width:'100%', borderCollapse: 'collapse', margin: '10px 0'}}>
                    <tr>
                        <th style={{padding: '10px'}}>Cookie Category</th>
                        <th style={{padding: '10px'}}>Default Retention</th>
                        <th style={{padding: '10px'}}>Maximum Retention</th>
                        <th style={{padding: '10px'}}>Renewal Policy</th>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>Essential</td>
                        <td style={{padding: '10px'}}>Session to 14 days</td>
                        <td style={{padding: '10px'}}>1 year</td>
                        <td style={{padding: '10px'}}>Renewed on each visit</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>Performance</td>
                        <td style={{padding: '10px'}}>30 days</td>
                        <td style={{padding: '10px'}}>2 years</td>
                        <td style={{padding: '10px'}}>Renewed with consent</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>Functionality</td>
                        <td style={{padding: '10px'}}>6 months</td>
                        <td style={{padding: '10px'}}>1 year</td>
                        <td style={{padding: '10px'}}>Renewed on preference change</td>
                    </tr>
                    <tr>
                        <td style={{padding: '10px'}}>Marketing</td>
                        <td style={{padding: '10px'}}>90 days</td>
                        <td style={{padding: '10px'}}>13 months</td>
                        <td style={{padding: '10px'}}>Not renewed without re-consent</td>
                    </tr>
                </table>

                <h3>13.2 Data Minimization</h3>
                <p>We follow data minimization principles for cookies:</p>
                <ul>
                    <li>Store only necessary information in cookies</li>
                    <li>Use session storage where persistent storage isn't required</li>
                    <li>Regularly purge expired cookie data</li>
                    <li>Anonymize or aggregate data where possible</li>
                </ul>

                <h2>14. Your Rights Regarding Cookies</h2>

                <h3>14.1 Rights by Jurisdiction</h3>
                <ul>
                    <li><strong>EU/UK (GDPR/UK GDPR):</strong>
                        <ul>
                            <li>Right to withdraw consent at any time</li>
                            <li>Right to access cookie data</li>
                            <li>Right to erasure of cookie data</li>
                            <li>Right to object to cookie usage</li>
                        </ul>
                    </li>
                    <li><strong>California (CCPA/CPRA):</strong>
                        <ul>
                            <li>Right to know what data is collected via cookies</li>
                            <li>Right to delete cookie data</li>
                            <li>Right to opt-out of sale/sharing via cookies</li>
                            <li>Right to non-discrimination</li>
                        </ul>
                    </li>
                    <li><strong>Other US States:</strong>
                        <ul>
                            <li>Virginia, Colorado, Connecticut, Utah: Similar rights to California</li>
                            <li>Right to opt-out of targeted advertising</li>
                            <li>Right to access and delete cookie data</li>
                        </ul>
                    </li>
                </ul>

                <h3>14.2 How to Exercise Your Rights</h3>
                <p>To exercise your cookie-related rights:</p>
                <ul>
                    <li><strong>Online:</strong> Use our Cookie Preference Center</li>
                    <li><strong>Email:</strong> privacy@intellommerce.ai</li>
                    <li><strong>Phone:</strong> +32 498 06 05 28</li>
                    <li><strong>Automated Tools:</strong> Browser settings and opt-out links</li>
                </ul>

                <h2>15. Cookie Walls and Access</h2>

                <h3>15.1 No Cookie Walls</h3>
                <p>We do not use "cookie walls" that force you to accept cookies to access our services. You can:</p>
                <ul>
                    <li>Access our website with only essential cookies</li>
                    <li>Use core functionality without accepting marketing cookies</li>
                    <li>Browse our content without full tracking</li>
                    <li>Make informed choices about optional cookies</li>
                </ul>

                <h3>15.2 Functionality Limitations</h3>
                <p>Some features may be limited without certain cookies:</p>
                <ul>
                    <li>Personalization features require functionality cookies</li>
                    <li>Saved preferences need persistent cookies</li>
                    <li>Some third-party integrations require their cookies</li>
                    <li>Advanced analytics features need performance cookies</li>
                </ul>

                <h2>16. Updates to This Cookie Policy</h2>

                <h3>16.1 Change Notifications</h3>
                <p>We will notify you of material changes to this policy through:</p>
                <ul>
                    <li>Prominent notice on our website</li>
                    <li>Email notification for registered users</li>
                    <li>In-app notifications for platform users</li>
                    <li>Re-requesting consent where required</li>
                </ul>

                <h3>16.2 Version Control</h3>
                <p>This policy is version controlled with the following history:</p>
                <ul>
                    <li><strong>Version 1.0 (Current):</strong> Sat Aug 23, 2025 - Comprehensive update for global
                        compliance
                    </li>
                    <li><strong>Version 1.0:</strong> Sat Aug 23, 2025 - Initial cookie policy</li>
                </ul>

                <h2>17. Contact Information</h2>

                <h3>17.1 Contact for Privacy Inquiries</h3>
                <p>While a formal Data Protection Officer is not required
                    for our operations, we take your privacy seriously. For any questions or concerns regarding this
                    privacy
                    policy or your data, please contact our designated team lead for privacy matters:</p>
                <p>
                    <strong>Email:</strong> privacy@intellommerce.ai<br/>
                </p>

                <h3>17.3 Regional Privacy Contacts</h3>
                <ul>
                    <li><strong>EU:</strong> Find your local authority at edpb.europa.eu</li>
                    <li><strong>UK:</strong> Information Commissioner's Office (ico.org.uk)</li>
                    <li><strong>California:</strong> California Privacy Protection Agency (cppa.ca.gov)</li>
                    <li><strong>Other Jurisdictions:</strong> Contact us for information about your local authority</li>
                </ul>

                <h2>18. Additional Resources</h2>

                <h3>18.1 Related Policies and Documents</h3>
                <ul>
                    <li><a href="/?modal=privacy">Privacy Policy</a> - Our comprehensive privacy practices</li>
                    <li><a href="/?modal=terms">Terms of Service</a> - Terms governing use of our services</li>
                </ul>

                <h3>18.2 External Resources</h3>
                <ul>
                    <li><a href="https://ico.org.uk/for-the-public/online/cookies/">ICO Cookie Guide</a> - UK
                        Information Commissioner's Office
                    </li>
                    <li><a href="https://www.cookielaw.org/">Cookie Law Information</a> - EU cookie law resources</li>
                    <li><a href="https://www.allaboutcookies.org/">All About Cookies</a> - Educational cookie
                        information
                    </li>
                    <li><a href="https://www.aboutads.info/">Digital Advertising Alliance</a> - Industry self-regulation
                    </li>
                </ul>

                <h2>19. Technical Implementation Details</h2>

                <h3>19.1 Consent Management Platform</h3>
                <p>We use a certified Consent Management Platform (CMP) that:</p>
                <ul>
                    <li>Complies with IAB Transparency and Consent Framework 2.0</li>
                    <li>Provides real-time consent synchronization</li>
                    <li>Supports granular purpose-based consent</li>
                    <li>Integrates with Google Consent Mode</li>
                    <li>Offers API access for custom implementations</li>
                </ul>

                <h3>19.2 Cookie Scanning and Discovery</h3>
                <p>Our automated cookie discovery process:</p>
                <ul>
                    <li>Scans for new cookies daily</li>
                    <li>Categorizes cookies automatically</li>
                    <li>Alerts on unauthorized cookie placement</li>
                    <li>Maintains comprehensive cookie inventory</li>
                    <li>Generates compliance reports</li>
                </ul>

                <h3>19.3 Technical Cookie Controls</h3>
                <ul>
                    <li><strong>Content Security Policy:</strong> Restricts unauthorized cookie setting</li>
                    <li><strong>Subresource Integrity:</strong> Verifies third-party script integrity</li>
                    <li><strong>Feature Policy:</strong> Controls browser feature access</li>
                    <li><strong>Referrer Policy:</strong> Manages referrer information in requests</li>
                </ul>

                <h2>20. Glossary of Cookie Terms</h2>

                <p><strong>Authentication Cookie:</strong> Verifies user identity and maintains login state</p>

                <p><strong>Cookie Banner:</strong> The notification that appears requesting cookie consent</p>

                <p><strong>Cookie Sync:</strong> Process of matching user IDs across different domains</p>

                <p><strong>Cross-Site Cookie:</strong> Cookie accessible across multiple websites</p>

                <p><strong>First-Party Cookie:</strong> Cookie set by the website you're visiting</p>

                <p><strong>Flash Cookie (LSO):</strong> Local Shared Object used by Adobe Flash</p>

                <p><strong>HttpOnly Cookie:</strong> Cookie that can't be accessed by client-side scripts</p>

                <p><strong>Persistent Cookie:</strong> Cookie that remains after browser is closed</p>

                <p><strong>SameSite Attribute:</strong> Controls when cookies are sent with cross-site requests</p>

                <p><strong>Secure Cookie:</strong> Cookie only transmitted over HTTPS connections</p>

                <p><strong>Session Cookie:</strong> Cookie deleted when browser session ends</p>

                <p><strong>Supercookie:</strong> Tracking method that's difficult to delete (we don't use these)</p>

                <p><strong>Third-Party Cookie:</strong> Cookie set by a domain other than the one visited</p>

                <p><strong>Tracking Pixel:</strong> Invisible image used to track user behavior</p>

                <p><strong>Zombie Cookie:</strong> Cookie that recreates itself after deletion (we don't use these)</p>

                <h2>21. Compliance Certifications</h2>

                <h3>21.1 Privacy Certifications</h3>
                <p>Our cookie practices are covered under our:</p>
                <ul>
                    <li>ISO 27701 Privacy Information Management certification</li>
                    <li>SOC 2 Type II attestation including privacy criteria</li>
                    <li>TRUSTe Privacy Certification</li>
                    <li>IAB Europe Transparency & Consent Framework participation</li>
                </ul>

                <h3>21.2 Regular Assessments</h3>
                <ul>
                    <li>Annual third-party privacy audits</li>
                    <li>Quarterly internal compliance reviews</li>
                    <li>Monthly automated compliance scanning</li>
                    <li>Continuous monitoring and alerting</li>
                </ul>

                <h2>22. Special Cookie Notices</h2>

                <h3>22.1 Government and Healthcare Customers</h3>
                <p>For customers in regulated industries:</p>
                <ul>
                    <li>Additional cookie restrictions may apply</li>
                    <li>Custom cookie configurations available</li>
                    <li>Compliance with sector-specific regulations</li>
                    <li>Enhanced audit trails and reporting</li>
                </ul>

                <h3>22.2 Workplace and Enterprise Use</h3>
                <p>When our services are used in workplace settings:</p>
                <ul>
                    <li>Employers may have additional policies</li>
                    <li>Corporate cookie settings may override individual preferences</li>
                    <li>Additional monitoring may be in place</li>
                    <li>Consult your organization's IT policies</li>
                </ul>

                <h2>23. Future Considerations</h2>

                <h3>23.1 Emerging Technologies</h3>
                <p>As technology evolves, we may adopt new tracking methods. We commit to:</p>
                <ul>
                    <li>Transparent disclosure of new technologies</li>
                    <li>Privacy-by-design implementation</li>
                    <li>Obtaining appropriate consent</li>
                    <li>Regular policy updates</li>
                </ul>

                <h3>23.2 Regulatory Changes</h3>
                <p>We actively monitor regulatory developments including:</p>
                <ul>
                    <li>Federal privacy legislation in the US</li>
                    <li>Updates to ePrivacy Regulation</li>
                    <li>New state privacy laws</li>
                    <li>International privacy frameworks</li>
                </ul>

                <hr style={{margin: '40px 0'}}/>

                <p style={{textAlign: 'center', fontStyle: 'italic'}}>
                    This Cookie Policy was last updated on Sat Aug 23, 2025.<br/>
                    © {new Date().getFullYear()} Intellommerce.ai. All rights reserved.<br/>
                    Cookie Policy Version 1.0<br/>
                    <br/>
                </p>
        </div>
</div>
)
    ;
};

export default TermsConditions;